const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

// Simply takes a Date object and returns the weekday name of its date
export default function(date) {
	return `${days[date.getDay()]}`;
}
